export default __webpack_public_path__ + "fedf6bb331a98a174a0a59c0c0a2b778.js";